import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Terms } from '../models/terms.model';
import { TermsAcceptance } from '../models/terms-acceptance.model';

@Injectable({
  providedIn: 'root'
})
export class TermsService {
  private termsEndpoint: string = "/terms";
  public terms;
  public hasAccepted: boolean = false;

  constructor(private apiService: ApiService) { }

  /**
   * Has this user signed the latest terms of service?
   */
  public verify(userId: string): Promise<any> {
    return new Promise( (resolve, reject) => {

      // should return a 200 if they're good, or a 204
      this.apiService.get(`${this.termsEndpoint}/verify?userId=${userId}`).then( (result) => {
        console.log("/verify result", result);
        this.hasAccepted = true;
        // if 200, return resolve()
        // if 204, throw new Error('Not acccepted')

        return resolve();
      }).catch( (error: any) => {

        this.retrieve(userId).then( (terms: Terms) => {
          console.log("Got the terms", terms);
          this.terms = terms;
          return reject(terms);

        }).catch( (error: any) => {
          console.log("Problem retrieving terms&conditions", error);
          return reject();
        });

      });

    });
  }

  /**
   * Gets the latest version of the terms of service
   */
  private retrieve(userId: string): Promise<Terms> {
    return this.apiService.get(`${this.termsEndpoint}/retrieve?userId=${userId}`);
  }

  /**
   * Creates an acceptance record for the user for a version of the terms
   */
  public accept(termsAcceptance: TermsAcceptance, userId: string): Promise<any> {
    this.hasAccepted = true;
    return this.apiService.post(`${this.termsEndpoint}/accept?userId=${userId}`, termsAcceptance);
  }

}
